var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-wrap"},[(_vm.$slots.default)?[_vm._t("default")]:_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab[_vm.filedKey],staticClass:"tab-item",class:{
        active: _vm.value === tab[_vm.filedKey]
      },on:{"click":function($event){$event.stopPropagation();return (() => _vm.onChange(tab)).apply(null, arguments)}}},[_vm._v(" "+_vm._s(tab[_vm.fieldLabel])+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }